import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import './tracking.css';
const ContainerDetails = ({ data = [], type }) => {
  const [expandedIndex, setExpandedIndex] = useState(0);
  const containers = Array.isArray(data) ? data : [];

  const handleToggle = (index) => {
    setExpandedIndex((prev) => (prev === index ? null : index));
  };

  function parseDate(str) {
    // Try YYYY-MM-DD HH:mm
    let d = str.replace(/-/g, '/');
    let date = new Date(d);
    if (!isNaN(date)) return date;
    // Try DD-MM-YYYY or DD-MM-YY
    const match = str.match(/(\d{2})-(\d{2})-(\d{2,4}) (\d{2}):(\d{2})/);
    if (match) {
      let [_, day, month, year, hour, min] = match;
      if (year.length === 2) year = '20' + year;
      return new Date(`${year}-${month}-${day}T${hour}:${min}`);
    }
    return new Date(str); // fallback
  }

  if (!containers.length) return null;

  return (
    <div className=''>
      {containers.map((containerData, index) => {
        const container = containerData?.attributes || {};
        const trackingDetails = container?.trackingDetails || [];
        const isExpanded = expandedIndex === index;

        return (
          <div
            key={container?.containerId || index}
            className='table-container'
          >
            <div className='container-details'>
              <div className='details-header header-ui'>
                <span>
                  <strong> Container:</strong>{' '}
                  {type !== 'containerId' ? container?.containerId : ''}
                </span>
                <span
                  role='button'
                  tabIndex={0}
                  onClick={() => handleToggle(index)}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      handleToggle(index);
                    }
                  }}
                  className='text-tprimary detail-btn cursor-pointer select-none'
                >
                  {isExpanded ? (
                    <>
                      Hide Details <FiChevronUp size={14} />
                    </>
                  ) : (
                    <>
                      More Details <FiChevronDown size={14} />
                    </>
                  )}
                </span>
              </div>
              <div className='details-content'>
                <div className='detail-item'>
                  <strong>Seal Number:</strong> {container?.sealNo || ''}
                </div>
                <div className='detail-item'>
                  <strong>Size/Type:</strong> {container?.size || ''}
                </div>
                <div className='detail-item'>
                  <strong>Weight:</strong> {container?.weight || ''}
                </div>
                <div className='detail-item'>
                  <strong>Measurement:</strong> {container?.measurement || ''}
                </div>
              </div>
            </div>
            {isExpanded && (
              <div className='table-scroll'>
                <table>
                  <thead>
                    <tr>
                      <th>Status</th>
                      <th>Place of Activity</th>
                      <th>Date/Time</th>
                      <th>Transport</th>
                      <th>Voyage</th>
                    </tr>
                  </thead>
                  <tbody>
                    {trackingDetails.length ? (
                      trackingDetails.map((item, rowIndex) => {
                        const isPast =
                          item?.date && parseDate(item.date) < new Date();
                        return (
                          <tr
                            key={`${
                              container?.containerId || index
                            }-${rowIndex}`}
                            className={isPast ? '' : 'text-tprimary'}
                          >
                            <td>{item?.event || ''}</td>
                            <td>{item?.location || ''}</td>
                            <td>{item?.date || ''}</td>
                            <td>{item?.vessel || ''}</td>
                            <td>{item?.voyage || ''}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={5}>No tracking details available.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ContainerDetails;
